// React
import React from 'react'
import classNames from 'classnames'
// Material UI
import { TransferWithinAStation as PickupIcon } from '@material-ui/icons'
// Components
import CustomStateLabel from '../common/custom-state-label'
// Const
import { textIds } from './const'
// Tools
import { useFormatMessage } from '../../intl/intl'
// Styles
import useStyles from './PickupLabel.styles'

const PickupLabel = ({ classes, ...props }) => {
  const componentClasses = useStyles()
  const pickUpLabelText = useFormatMessage(textIds.pickUpLabelText)

  return (
    <CustomStateLabel
      classes={{
        root: classNames(componentClasses.root, classes.root),
        iconRoot: classNames(componentClasses.iconRoot, classes.iconRoot),
      }}
      Icon={PickupIcon}
      {...props}
      stateMessage={pickUpLabelText}
    />
  )
}

export default PickupLabel
